import { Box, LinearProgress, Typography } from '@mui/material';

import React from 'react';

import { formatNumber, prepareChartData } from '../_utils/chartHelpers';

/**
 * A list item component displaying a label, a formatted value, and a progress bar.
 * @param {Object} props - Component props.
 * @param {string} props.label - The main text label for the item (e.g., page path).
 * @param {number} props.value - The numerical value associated with the item (e.g., page views).
 * @param {number} props.percentage - The percentage (0-100) for the progress bar.
 * @param {string} [props.color='primary'] - The color of the progress bar (MUI color name).
 */
function ProgressListItem({ label, value, percentage, color = 'primary' }) {
  return (
    <Box sx={{ mb: 1.5 }}>
      {' '}
      {/* Margin bottom for spacing between items */}
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          mb: 0.5,
        }}
      >
        <Typography
          variant='body2'
          sx={{ fontWeight: 'medium', flexGrow: 1, minWidth: 0, pr: 1 }}
        >
          {label}
        </Typography>
        <Typography variant='body2' sx={{ fontWeight: 'bold', flexShrink: 0 }}>
          {formatNumber(value)}
        </Typography>
      </Box>
      <LinearProgress
        variant='determinate'
        value={percentage}
        color={color}
        sx={{ height: 6, borderRadius: 3 }} // Thinner, rounded progress bar
      />
    </Box>
  );
}

export default ProgressListItem;
